module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hLjV9"))).then(() => parcelRequire('iDabs'));